import React from 'react';
import { useTranslation } from 'react-i18next';
import {
  Box,
  TextField,
  Typography,
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Alert,
  CircularProgress,
} from '@mui/material';

function ReviewDialog({
  open,
  onClose,
  onSubmit,
  reviewAction,
  reviewProposal,
  reviewNotes,
  setReviewNotes,
  reviewing,
}) {
  const { t } = useTranslation();
  
  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>
        {reviewAction === 'approve' 
          ? t('observations.approveProposal', 'Approve Proposal') 
          : t('observations.rejectProposal', 'Reject Proposal')}
      </DialogTitle>
      <DialogContent>
        {reviewProposal && (
          <Box sx={{ mb: 2 }}>
            <Typography variant="body2" sx={{ mb: 1 }}>
              <strong>{t('observations.indicator', 'Indicator')}:</strong> {reviewProposal.indicator_id}
            </Typography>
            <Typography variant="body2" sx={{ mb: 1 }}>
              <strong>{t('observations.date')}:</strong> {reviewProposal.observation_date}
            </Typography>
            <Typography variant="body2" sx={{ mb: 1 }}>
              <strong>{t('observations.extractedValue', 'Extracted Value')}:</strong> {reviewProposal.extracted_value?.toFixed(2)}
            </Typography>
            <Typography variant="body2" sx={{ mb: 2 }}>
              <strong>{t('observations.confidence', 'Confidence')}:</strong> {(reviewProposal.confidence * 100).toFixed(0)}%
            </Typography>
          </Box>
        )}

        {reviewAction === 'approve' && reviewProposal?.current_value !== null && (
          <Alert severity="warning" sx={{ mb: 2 }}>
            {t('observations.willOverwriteWarning', 'This will overwrite the existing value')} ({reviewProposal.current_value?.toFixed(2)})
          </Alert>
        )}

        <TextField
          label={t('observations.addNotes', 'Add notes...')}
          fullWidth
          multiline
          rows={3}
          value={reviewNotes}
          onChange={(e) => setReviewNotes(e.target.value)}
          placeholder={t('observations.reviewNotesPlaceholder', 'Optional: Add reason for approval/rejection')}
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} disabled={reviewing}>
          {t('observations.cancel')}
        </Button>
        <Button 
          onClick={onSubmit} 
          variant="contained" 
          color={reviewAction === 'approve' ? 'success' : 'error'}
          disabled={reviewing}
        >
          {reviewing 
            ? <CircularProgress size={24} /> 
            : (reviewAction === 'approve' ? t('observations.approve', 'Approve') : t('observations.reject', 'Reject'))}
        </Button>
      </DialogActions>
    </Dialog>
  );
}

export default ReviewDialog;
